import { NgModule } from '@angular/core';
import { LibSharedCommonModule } from '@solvace/common';
import { MatIconModule } from '@angular/material/icon';
import { SvcToastItemComponent } from './svc-toast-item/svc-toast-item.component';
import { SvcToastComponent } from './svc-toast/svc-toast.component';

@NgModule({
  declarations: [
    SvcToastComponent,
    SvcToastItemComponent,
  ],
  imports: [
    LibSharedCommonModule,
    MatIconModule,
  ],
  exports: [
    SvcToastComponent,
    SvcToastItemComponent,
  ]
})
export class SvcToastModule { }
